export default "__VITE_ASSET__c66ed58d__"